<template>
  <div class="currency-input clearfix">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <div class="input-group">
          <input class="form-control" type="text"
            :id="options.name"
            :value="value"
            @input="validate($event.target.value)"
            :name="options.name"/>
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationMessage,
  validationIcon
} from '@/util/helpers'

export default {
  name: 'PercentageInput',
  props: {
    value: {
      type: [Number, String]
    },
    options: {
      type: Object,
      default () {
        return {
          value: '0'
        }
      }
    }
  },
  data () {
    return {
      isLength: false,
      isRegex: false,
      regex: /^[0-9]*(\.{1}[0-9]{1,2})*$/,
      isValid: false,
      isDirty: false
    }
  },
  computed: {
    validationClass,
    validationMessage,
    validationIcon
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      this.isDirty = true
      this.isLength = this.isValid = val.length !== 0
      if (this.isLength) {
        this.isRegex = this.isValid = new RegExp(this.regex, 'gi').test(val)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/PercentageInput.vue